import { forwardRef } from 'react';
import { ChartHR } from '@/entities/heart-rate';
import useAfibHrChart from './useAfibHrChart';

export type AfibHrChartHandle = {
  handleClickArrowButton: (isNext: boolean) => void;
};

export type AfibHrChartProps = {
  studyId: string;
  profileId: string;
  timezoneOffset: number;
  ecgDataMap: any;
};

/**
 * Renders the heart rate chart underneath the AFib events list. Pulls the tab key, chart data, updated selected strip and chart ref from the hook and forwards them to the shared heart rate chart, cast to any because that component is still plain JS and infers no props.
 *
 * @param props - The AFib chart props, providing the timezone offset used for the chart axis.
 * @param ref - Forwarded handle the parent uses to drive the underlying chart.
 * @returns The rendered AFib heart rate chart.
 */
const AfibHrChart = forwardRef<AfibHrChartHandle, AfibHrChartProps>(
  ({ studyId, profileId, timezoneOffset, ecgDataMap }, ref) => {
    const { keyRecoil, dataChart, updatedSelectedStrip, chartHrRef } = useAfibHrChart(
      { studyId, profileId, timezoneOffset, ecgDataMap },
      ref,
    );

    // ChartHR is still plain JS (forwardRef without a props generic, Task 10) - TS infers no props at all.
    const ChartHRAny = ChartHR as any;
    return (
      <ChartHRAny
        ref={chartHrRef}
        idHtmlChart="afib-events-hr-chart-container"
        keyRecoil={keyRecoil}
        dataChart={dataChart}
        updatedSelectedStrip={updatedSelectedStrip}
        timezoneOffset={timezoneOffset}
        minWidth={1395}
      />
    );
  },
);

export default AfibHrChart;
